var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-date-picker", {
    attrs: {
      type: "date",
      format: _vm.datePickerFormat,
      valueFormat: "yyyy-MM-dd",
      pickerOptions: _vm.datePickerOptions,
      placeholder: _vm.$t.__("common.labels.date")
    },
    model: {
      value: _vm.date,
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }